<template>
  <div>
    <el-container>
      <el-header height="auto">
        <Head></Head>
      </el-header>
<!--      <Top v-show="showTop"></Top>-->

      <el-main>
        <div style="max-width:1920px;min-height: 300px;margin: 0 auto;position: relative">
<!--          <menuSide v-if="showTop"></menuSide>-->
          <router-view></router-view>
          <right-fixed></right-fixed>
        </div>
      </el-main>
      <el-footer height="139px">
        <Foot></Foot>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import Head from './components/menu-header/index'
  import Foot from './components/foot'
  import Top from './components/top'
  import rightFixed from './components/right-fixed'
  import {mapState} from "vuex";
  import menuSide from "@/layouts/HeaderAside/components/menu-side/index.vue";

  export default {
    name: 'layout-head',
    components: {
      menuSide,
      Head,
      Foot,
      Top,
      rightFixed
    },
    data () {
      return {
        showTop:false,
        // [侧边栏宽度] 正常状态
        asideWidth: '260px',
        // [侧边栏宽度] 折叠状态
        asideWidthCollapse: '65px'
      }
    },
    computed: {
      ...mapState('d2admin', {
        asideCollapse: state => state.menu.asideCollapse
      }),
    },
    created(){
      this.updatePath()
    },
    updated(){
      this.updatePath()
    },
    methods: {
      updatePath(){
        if(this.$route.fullPath.indexOf('/commerce') != -1||this.$route.fullPath.indexOf('/container') != -1 ||this.$route.fullPath.indexOf('/transport') != -1|| this.$route.fullPath.indexOf('/track') != -1|| (!this.$route.meta.hasOwnProperty('title'))){
          if(this.$route.fullPath === '/transportDetil'||this.$route.fullPath === '/industryInfo'||this.$route.fullPath === '/newsDetail'||this.$route.fullPath === '/forgetPW'){
            this.showTop = false;
          }else{
            this.showTop = true;
          }
        }else{
          this.showTop = false;
        }
      },
    }
  }
</script>

<style lang="scss">
.el-footer{
  padding: 0!important;
}
</style>
